import axiosClient from "../requests/axiosCLient";
import { API_URLS } from "../../constants/constants";

export const getHeaderDetails = () => {
  const url = API_URLS.headerEndPoint;
  return axiosClient.get(url);
};
